<template>
  <b-container id="card-details-page" v-if="isDataLoaded" fluid>
    <b-row id="card-details-form">
      <b-col md="11" lg="8" class="mx-auto">
        <b-row>
          <b-col md="1">
            <img
              src="@/assets/images/credit-card-visa-master.png"
              alt="Credit Card"
            />
          </b-col>
          <b-col md="11" class="mt-3 mt-md-0">
            <span class="h4">Credit Card</span>
          </b-col>
        </b-row>
        <div class="border rounded px-0 pb-3 mt-5 bg-white">
          <b-row class="px-3 pt-3 pb-1">
            <b-col> Purchase Amount </b-col>
          </b-row>
          <b-row class="px-3">
            <b-col>
              <span class="h4"
                >&#8369; {{ orderDetails ? orderDetails.computed_total : 0 | currency }}</span
              >
            </b-col>
            <b-col class="position-relative">
              <div v-b-toggle.collapse-purchase-details class="chevron-toggle">
                <img
                  src="@/assets/images/chevron-up.png"
                  alt="Chevron Up"
                  class="chevron-icon when-opened"
                />
                <img
                  src="@/assets/images/chevron-down.png"
                  alt="Chevron Down"
                  class="chevron-icon when-closed"
                />
              </div>
            </b-col>
          </b-row>
          <b-collapse
            id="collapse-purchase-details"
            class="border-top mt-2 pt-3"
          >
            <b-container>
              <b-row>
                <b-col cols="5"> Subtotal </b-col>
                <b-col cols="7" class="text-right font-weight-bold">
                  &#8369; {{ orderDetails ? orderDetails.total : 0 | currency }}
                </b-col>
              </b-row>
              <b-row
                v-if="orderDetails && orderDetails.voucher_code && orderDetails.voucher_amount"
                class="mt-2"
              >
                <b-col cols="5">
                  Discount ({{ orderDetails.voucher_code }})</b-col
                >
                <b-col cols="7" class="text-right font-weight-bold">
                  - &#8369; {{ orderDetails.voucher_amount | currency }}
                </b-col>
              </b-row>
              <b-row class="mt-2" v-for="(fee, index) in fees" :key="index">
                <b-col cols="5">{{ fee.name }}</b-col>
                <b-col cols="7" class="text-right font-weight-bold">
                  &#8369; {{ fee.value | currency }}
                </b-col>
              </b-row>
              <hr />
              <b-row class="mt-2">
                <b-col> Total Payment </b-col>
                <b-col class="text-right font-weight-bold">
                  &#8369;
                  {{ orderDetails ? orderDetails.computed_total : 0 | currency }}
                </b-col>
              </b-row>
            </b-container>
          </b-collapse>
        </div>
        <b-row class="my-4">
          <b-col>
            <span class="h4 font-weight-normal"
              >Billing and Contact Details</span
            >
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col>
            <b-form-radio-group
              v-model="isSameAsDeliveryAddress"
              class="select-address-details"
              stacked
            >
              <b-form-radio :value="true" class="m-3">
                Same as delivery address
              </b-form-radio>
              <hr />
              <b-form-radio :value="false" class="m-3">
                Use a different billing address
              </b-form-radio>
            </b-form-radio-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div class="mt-3">
              <div>
                <b-row class="mt-3">
                  <b-col md="6">
                    <div class="floating-field-container">
                      <div class="floating-field">
                        <input
                          type="text"
                          v-model="form.firstName"
                          placeholder=" "
                          :disabled="isSameAsDeliveryAddress"
                        />
                        <label>First Name</label>
                      </div>
                    </div>
                    <b-form-invalid-feedback :state="validate('firstName')">
                      {{ displayError("firstName") }}
                    </b-form-invalid-feedback>
                  </b-col>
                  <b-col md="6" class="mt-3 mt-md-0">
                    <div class="floating-field-container">
                      <div class="floating-field">
                        <input
                          type="text"
                          v-model="form.lastName"
                          placeholder=" "
                          :disabled="isSameAsDeliveryAddress"
                        />
                        <label>Last Name</label>
                      </div>
                    </div>
                    <b-form-invalid-feedback :state="validate('lastName')">
                      {{ displayError("lastName") }}
                    </b-form-invalid-feedback>
                  </b-col>
                </b-row>
                <b-row class="mt-3">
                  <b-col>
                    <div class="floating-field-container">
                      <div class="floating-field">
                        <input
                          type="text"
                          inputmode="numeric"
                          pattern="[0-9]*"
                          v-model="form.mobileNumber"
                          placeholder=" "
                          maxlength="11"
                          :disabled="isSameAsDeliveryAddress"
                        />
                        <label>Mobile Number</label>
                      </div>
                    </div>
                    <b-form-invalid-feedback :state="validate('mobileNumber')">
                      {{ displayError("mobileNumber") }}
                    </b-form-invalid-feedback>
                  </b-col>
                </b-row>
                <b-row class="mt-3">
                  <b-col>
                    <div class="floating-field-container">
                      <div class="floating-field">
                        <input
                          type="text"
                          v-model="form.email"
                          placeholder=" "
                          :disabled="isSameAsDeliveryAddress"
                        />
                        <label>Email Address</label>
                      </div>
                    </div>
                    <b-form-invalid-feedback :state="validate('email')">
                      {{ displayError("email") }}
                    </b-form-invalid-feedback>
                  </b-col>
                </b-row>
                <b-row class="mt-3">
                  <b-col>
                    <div class="floating-field-container">
                      <div class="floating-field">
                        <input
                          type="text"
                          v-model="form.address1"
                          placeholder=" "
                          :disabled="isSameAsDeliveryAddress"
                        />
                        <label>Address Line 1</label>
                      </div>
                    </div>
                    <b-form-invalid-feedback :state="validate('address1')">
                      {{ displayError("address1") }}
                    </b-form-invalid-feedback>
                  </b-col>
                </b-row>
                <b-row class="mt-3">
                  <b-col>
                    <div class="floating-field-container">
                      <div class="floating-field">
                        <input
                          type="text"
                          v-model="form.address2"
                          placeholder=" "
                        />
                        <label>Address Line 2</label>
                      </div>
                    </div>
                    <b-form-invalid-feedback :state="validate('address2')">
                      {{ displayError("address2") }}
                    </b-form-invalid-feedback>
                  </b-col>
                </b-row>
                <b-row class="mt-3" v-if="provinces">
                  <b-col>
                    <b-dropdown
                      variant="link"
                      class="dropdown-select"
                      no-caret
                      menu-class="w-100"
                      :disabled="isSameAsDeliveryAddress"
                    >
                      <template slot="button-content">
                        <b-container class="position-relative">
                          <label>State/Province</label>
                          <b-row>
                            <b-col class="text-left pl-0">
                              {{ form.region ? form.region : "Select" }}
                            </b-col>
                            <b-col class="text-right pr-0">
                              <img
                                src="@/assets/images/chevron-down.png"
                                alt="Dropdown"
                                class="chevron-icon mb-1"
                              />
                            </b-col>
                          </b-row>
                        </b-container>
                      </template>
                      <b-dropdown-item disabled> Select </b-dropdown-item>
                      <b-dropdown-item
                        v-for="(province, index) in provinceList"
                        :key="index"
                        @click="loadCities((form.region = province.name))"
                      >
                        {{ province.name }}
                      </b-dropdown-item>
                    </b-dropdown>
                    <b-form-invalid-feedback :state="validate('region')">
                      {{ displayError("region") }}
                    </b-form-invalid-feedback>
                  </b-col>
                </b-row>
                <b-row class="mt-3">
                  <b-col md="6" v-if="cities">
                    <b-dropdown
                      variant="link"
                      class="dropdown-select"
                      no-caret
                      menu-class="w-100"
                      :disabled="
                        isSameAsDeliveryAddress ||
                          !form.region ||
                          cityList.length === 0
                      "
                    >
                      <template slot="button-content">
                        <b-container class="position-relative">
                          <label>City</label>
                          <b-row>
                            <b-col class="text-left pl-0">
                              {{
                                form.city
                                  ? form.city
                                  : `${
                                      loadingCities
                                        ? "Loading cities..."
                                        : "Select"
                                    }`
                              }}
                            </b-col>
                            <b-col class="text-right pr-0">
                              <img
                                src="@/assets/images/chevron-down.png"
                                alt="Dropdown"
                                class="chevron-icon mb-1"
                              />
                            </b-col>
                          </b-row>
                        </b-container>
                      </template>
                      <b-dropdown-item disabled> Select </b-dropdown-item>
                      <b-dropdown-item
                        v-for="(city, index) in cityList"
                        :key="index"
                        @click="form.city = city.name"
                      >
                        {{ city.name }}
                      </b-dropdown-item>
                    </b-dropdown>
                    <b-form-invalid-feedback :state="validate('city')">
                      {{ displayError("city") }}
                    </b-form-invalid-feedback>
                  </b-col>
                  <b-col md="6" class="mt-3 mt-md-0">
                    <div class="floating-field-container">
                      <div class="floating-field">
                        <input
                          type="text"
                          inputmode="numeric"
                          pattern="[0-9]*"
                          v-model="form.postalCode"
                          placeholder=" "
                          maxlength="4"
                        />
                        <label>Postal Code</label>
                      </div>
                    </div>
                    <b-form-invalid-feedback :state="validate('postalCode')">
                      {{ displayError("postalCode") }}
                    </b-form-invalid-feedback>
                  </b-col>
                </b-row>
                <b-row class="mt-3">
                  <b-col>
                    <b-dropdown
                      variant="link"
                      class="dropdown-select"
                      no-caret
                      menu-class="w-100"
                      disabled
                    >
                      <template slot="button-content">
                        <b-container class="position-relative">
                          <label>Country</label>
                          <b-row>
                            <b-col class="text-left pl-0">
                              {{ form.country ? form.country : "Select" }}
                            </b-col>
                            <b-col class="text-right pr-0">
                              <img
                                src="@/assets/images/chevron-down.png"
                                alt="Dropdown"
                                class="chevron-icon mb-1"
                              />
                            </b-col>
                          </b-row>
                        </b-container>
                      </template>
                    </b-dropdown>
                    <b-form-invalid-feedback :state="validate('country')">
                      {{ displayError("country") }}
                    </b-form-invalid-feedback>
                  </b-col>
                </b-row>
                <!-- <b-row class="mt-4" v-if="!isSameAsDeliveryAddress">
                  <b-col>
                    <b-form-checkbox v-model="isSaveBillingDetails">
                      Save billing details for future transactions
                    </b-form-checkbox>
                  </b-col>
                </b-row> -->
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-5">
          <b-col class="text-center text-md-left">
            <b-link class="h6 text-secondary" :to="{ name: 'Checkout', params: { checkout_uuid: this.checkoutId } }">
              Cancel and return to website
            </b-link>
          </b-col>
          <b-col md="4" class="text-center text-md-left mt-3 mt-md-0">
            <b-button
              variant="primary"
              class="btn-core border-0 px-1"
              block
              :style="{
                backgroundColor: `${design.main_color} !important`,
                color: `${design.button_text_color} !important`
              }"
              @click="proceedToPayment"
            >
              Proceed to Payment
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row id="card-details-footer">
      <b-container class="px-4 pb-3">
        <b-row class="mt-3">
          <b-col class="d-flex justify-content-between">
            <div>
              <img src="@/assets/images/lock.png" id="lock" alt="Secured" />
              <small class="text-white align-middle ml-1">
                Secured Payment
              </small>
            </div>

            <div>
              <small class="text-white align-middle"> Powered by </small>
              <img
                src="@/assets/images/paymongo-green.png"
                id="paymongo"
                alt="Secured"
              />
            </div>
          </b-col>
        </b-row>
      </b-container>
    </b-row>
  </b-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import _ from "lodash";
import { ls } from "@/utilities";

export default {
  name: "CardDetails",
  data() {
    return {
      orderId: null,
      checkoutId: null,
      isDataLoaded: false,
      form: {
        firstName: "",
        lastName: "",
        mobileNumber: "",
        email: "",
        address1: "",
        address2: "",
        city: "",
        postalCode: "",
        region: "NCR",
        country: "Philippines"
      },
      isSameAsDeliveryAddress: true,
      isSaveBillingDetails: false,
      user: null
    };
  },
  filters: {
    currency(value) {
      return new Intl.NumberFormat("en-US", {
        style: "decimal",
        minimumFractionDigits: 2
      }).format(Number.parseFloat(value).toFixed(2));
    }
  },
  computed: {
    ...mapState("estore", ["orderDetails"]),
    ...mapState("merchant", ["customerPortalToken"]),
    ...mapGetters({
      design: "estore/design",
      loadingCities: "customer/loading",
      provinces: "customer/provinces",
      cities: "customer/cities",
      customerToken: "customer/customerToken",
      errors: "customer/errors"
    }),
    provinceList() {
      return this.provinces && this.provinces.provinces
        ? this.provinces.provinces
        : [];
    },
    cityList() {
      return this.cities && this.cities.cities ? this.cities.cities : [];
    },
    fees() {
      if (!this.orderDetails) return [];

      const fees = _.flatten(this.orderDetails.orders.map(order => order.fees));

      return _(fees)
        .groupBy("name")
        .map(fee => ({
          ...fees[0],
          value: _.sumBy(fee, item => Number(item.value))
        }))
        .value();
    },
    addressDetails() {
      const address = ls.get('customer_address');

      if (!address) return [];

      return `${address.delivery_address_details}|${address.delivery_address}`;
    },
    isEmail() {
      const isEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/; //eslint-disable-line
      return isEmail.test(this.form.email);
    },
    isMobile() {
      const isNum = /^\d+$/;
      const firstDigits = this.form.mobileNumber.substring(0, 2);
      return isNum.test(this.form.mobileNumber)
        ? this.form.mobileNumber.length === 11 && firstDigits === "09"
        : false;
    }
  },
  watch: {
    isSameAsDeliveryAddress(value) {
      this.$store.commit("customer/RESET_ERRORS");

      if (value) this.useSameAsDeliveryAddressData();
      else this.useDifferentBillingAddressData();
    },
    "form.mobileNumber"() {
      this.form.mobileNumber = this.form.mobileNumber.replace(/\D/g, "");
    },
    "form.postalCode"() {
      this.form.postalCode = this.form.postalCode.replace(/\D/g, "");
    }
  },
  methods: {
    useSameAsDeliveryAddressData() {
      const user = ls.get('customer_info');
      const user_contact = ls.get('customer_contact');
      this.form.firstName = user.first_name;
      this.form.lastName = user.last_name;
      this.form.mobileNumber =
        user_contact.mobile_number.substring(0, 1) !== "0"
          ? `0${user_contact.mobile_number}`
          : user_contact.mobile_number;
      this.form.email = user_contact.email;
      this.form.address1 = this.addressDetails.split("|")[0];
      this.form.address2 = "";
      this.form.postalCode = "";
      this.form.city = this.addressDetails
        .split("|")[1]
        .split(",")
        .slice(-3)[0]
        .trim();
      this.form.region = this.addressDetails
        .split("|")[1]
        .split(",")
        .slice(-2)[0]
        .trim();
    },
    useDifferentBillingAddressData() {
      if (this.user && this.user.billing_info) {
        const {
          firstname,
          lastname,
          mobile_number,
          email,
          address_line1,
          address_line2,
          postal_code,
          city,
          state
        } = this.user.billing_info;

        this.form.firstName = firstname;
        this.form.lastName = lastname;
        this.form.mobileNumber = mobile_number;
        this.form.email = email;
        this.form.address1 = address_line1;
        this.form.address2 = address_line2;
        this.form.postalCode = postal_code;
        this.form.city = city;
        this.form.region = state;
      } else {
        this.form.firstName = "";
        this.form.lastName = "";
        this.form.mobileNumber = "";
        this.form.email = "";
        this.form.address1 = "";
        this.form.address2 = "";
        this.form.postalCode = "";
        this.form.city = "";
        this.form.region = "";
      }
    },
    validate(key) {
      if (this.errors && key in this.errors) return false;

      return null;
    },
    displayError(key) {
      if (this.errors && key in this.errors)
        return Array.isArray(this.errors[key])
          ? this.errors[key].join(" ")
          : this.errors[key];

      return "";
    },
    async saveBillingInfo(payload) {
      const request = {
        header: {
          Authorization: this.customerToken,
          "X-Merchant-Token": this.customerPortalToken
        },
        payload
      };
      await this.$store.dispatch("customer/saveBillingInfo", request);
    },
    async proceedToPayment() {
      const errors = {};
      this.$store.commit("customer/RESET_ERRORS");

      for (const field in this.form) {
        if (!this.form[field].trim()) errors[field] = "This field is required.";
        if (field === "email" && !this.isEmail)
          errors[field] = "Invalid email address.";
        if (field === "mobileNumber" && !this.isMobile)
          errors[field] = "Invalid mobile number.";
      }

      if (Object.keys(errors).length) {
        this.$store.commit("customer/SET_ERRORS", errors);

        return;
      }

      const payload = {
        firstname: this.form.firstName,
        lastname: this.form.lastName,
        email: this.form.email,
        mobile_number: this.form.mobileNumber,
        address_line1: this.form.address1,
        address_line2: this.form.address2,
        city: this.form.city,
        state: this.form.region,
        postal_code: this.form.postalCode,
        country: this.form.country
      };

      if (this.isSaveBillingDetails) {
        await this.saveBillingInfo(payload);

        if (!this.errors)
          this.$router.push({
            name: "CardPayment",
            query: { orderId: this.orderId, ...this.form }
          });

        return;
      }

      this.$router.push({
        name: "CardPayment",
        query: { orderId: this.orderId, ...this.form }
      });
    },
    async getOrderDetails() {
      const request = {
        header: {
          "X-Merchant-Token": this.customerPortalToken
        },
        tracking_uuid: this.orderId
      };
      await this.$store.dispatch("estore/getOrderDetails", request);
    },
    async getCities() {
      const request = {
        header: {
          "X-Merchant-Token": this.customerPortalToken
        },
        payload: {
          province: this.form.region
        }
      };
      await this.$store.dispatch("customer/getCities", request);
    },
    async getProvinces() {
      const request = {
        header: {
          "X-Merchant-Token": this.customerPortalToken
        }
      };

      await this.$store.dispatch("customer/getProvinces", request);
    },
    async loadCities() {
      this.form.city = "";
      await this.getCities();
    }
  },
  async created() {
    const { orderId, checkoutId } = this.$route.query;

    if (!orderId) {
      this.$router.push({ path: "404" });

      return;
    }

    this.orderId = orderId;
    this.checkoutId = checkoutId;
    this.$store.commit("customer/RESET_ERRORS");

    await this.getOrderDetails();
    await this.getProvinces();
    await this.getCities();
    this.useSameAsDeliveryAddressData();
    this.isDataLoaded = true;
  }
};
</script>

<style lang="scss">
@import "@/assets/styles/views/checkout/_card-details.scss";
</style>
